module.exports = __webpack_public_path__ + "media/images/mobile/home/next_btn-519b4e61591c207d2cdb179c696f8eb3.png";